// extracted by mini-css-extract-plugin
export default {"container":"EquipmentDetails_container__yCN7c","tabs":"EquipmentDetails_tabs__YdQLS","detailsSection":"EquipmentDetails_detailsSection__ABcr+"};